import type { AiHint } from '../../../widgets';
import { CheckboxField, Section, TextField } from '../fields';

/**
 * Der KI-Hinweis der Kachel-Widgets.
 *
 * Normalfall: leer lassen. Die C#-Records tragen je Typ einen eigenen
 * Hinweis, und der Vorschlags-Dienst liest ihn von dort. Ein hier gesetzter
 * Block ersetzt ihn vollstaendig, also nur fuer den Fall gedacht, dass eine
 * Anlage wirklich anders funktioniert als der Regelfall und die Vorschlaege
 * sonst danebenliegen.
 *
 * Die drei Listen werden als Reihe getrennter Woerter eingegeben. Ein eigener
 * Listeneditor je Wortliste waere hier mehr Bedienung als Nutzen: es sind
 * kurze Wortmarken, keine strukturierten Eintraege.
 */
export function AiHintSection(props: {
  value: AiHint | undefined;
  onChange(next: AiHint | undefined): void;
}) {
  const hint = props.value;
  const set = (part: Partial<AiHint>) => props.onChange({
    purpose: '',
    fitsLeafKinds: [],
    fitsMetricKinds: [],
    suggestsOtherWidgets: [],
    ...hint,
    ...part,
  });

  return (
    <Section
      title="KI-Hinweis"
      hint="Nur setzen, wenn die Vorschläge für diese Anlage danebenliegen. Sonst gilt der Hinweis aus dem Schema."
    >
      <CheckboxField
        label="Eigenen Hinweis hinterlegen"
        checked={hint !== undefined}
        onChange={(on) => props.onChange(on
          ? { purpose: '', fitsLeafKinds: [], fitsMetricKinds: [], suggestsOtherWidgets: [] }
          : undefined)}
      />
      {hint && (
        <>
          <TextField
            label="Zweck"
            value={hint.purpose}
            keepEmptyString
            placeholder="Ein Satz: welches Problem des Bedieners löst diese Kachel?"
            onChange={(next) => set({ purpose: next ?? '' })}
          />
          <TextField
            label="Passende Punktarten"
            value={hint.fitsLeafKinds.join(' ')}
            keepEmptyString
            placeholder="Float Enum Bool"
            onChange={(next) => set({ fitsLeafKinds: words(next) })}
          />
          <TextField
            label="Passende Messgrößen"
            value={hint.fitsMetricKinds.join(' ')}
            keepEmptyString
            placeholder="Instantaneous Setpoint State"
            onChange={(next) => set({ fitsMetricKinds: words(next) })}
          />
          <TextField
            label="Passt zusammen mit"
            value={hint.suggestsOtherWidgets.join(' ')}
            keepEmptyString
            placeholder="trend room-thermostat"
            onChange={(next) => set({ suggestsOtherWidgets: words(next) })}
          />
        </>
      )}
    </Section>
  );
}

function words(raw: string | undefined): string[] {
  return (raw ?? '').split(/[\s,]+/).filter((w) => w.length > 0);
}
